export default {
  // 注册联系人
  personInfo: Object.freeze([
    { label: "店长:", fieldName: "shopManager" },
    { label: "手机号:", fieldName: "shopManagerPhone" },
  ]),
  compInfo: Object.freeze([
    { label: "公司名称:", fieldName: "businessName" },
    { label: "公司简称:", fieldName: "businessShortname" },
    { label: "统一社会信用代码:", fieldName: "unifiedCode" },
  ]),
  shopInfo: Object.freeze([
    { label: "店铺类型:", fieldName: "shopTypeStr" },
    { label: "承运商类型:", fieldName: "shopSupplierSubcategoryBOList",slot: 'subcategory' },
    { label: "店铺名称:", fieldName: "shopName" },
    { label: "店铺LOGO:", fieldName: "shopLogoUrl" ,slot: "file"},
    { label: "主营区域:", fieldName: "shopAddress", slot: "quyu" },
    { label: "货物类型:", fieldName: "shopBusinessCategoryScopeBOS", slot:'category' },
    { label: "店铺经营地址:", fieldName: "shopAddress" },
    { label: "客服电话:", fieldName: "supportPhone" },
    { label: "店铺简介:", fieldName: "shopBrief" },
  ]),
  fileInfo: Object.freeze([
    { label: "委托授权书:", fieldName: "shopAptitudeInfoBOS", slotObj: "file" },
    { label: "承运商合作框架协议:", fieldName: "shopAgreementFileBOS", slotObj: "file" },
  ]),
  orderMessage: Object.freeze([
    { label: "订单编号:", fieldName: "orderCode", span: 12 },
    {
      label: "服务费金额（元）:",
      fieldName: "orderMoney",
      span: 12,
      html: true,
      formateFn: function (val) {
        return `<span style="color: red; font-size: 16px;">￥${val ||
          3000.0}</span>`;
      }
    },
    {
      label: "服务名称:",
      fieldName: "serveName",
      span: 12,
      formateFn: function (val) {
        return "店铺年服务费";
      }
    },
    {
      label: "订单状态:",
      fieldName: "payStatus",
      span: 12,
      formateFn: function (val) {
        const orderStatusMap = {
          0: "待支付",
          1: "已支付",
          2: "已退款",
          6: "支付待确认",
          7: "已关闭"
        };
        return orderStatusMap[val] || val;
      }
    },
    { label: "供应商名称:", fieldName: "supplierName", span: 12 },
    {
      label: "支付方式:",
      fieldName: "payType",
      span: 12,
      formateFn: function (val) {
        const payTypeMap = {
          0: "-",
          11: "微信支付",
          12: "公对公转账"
        };
        return payTypeMap[val] || val;
      }
    },
    {
      label: "订单类型:",
      fieldName: "orderPurchaseType",
      span: 12,
      formateFn: function (val) {
        const types = {
          9: "店铺服务费",
          12: "中标增值服务费"
        };
        return types[val] || val;
      }
    },
    { label: "下单时间:", fieldName: "createTime", span: 12 },
    { label: "支付时间:", fieldName: "payTime", span: 12 },
    { label: "生效时间:", fieldName: "effectiveTime", span: 12 },
    { label: "到期时间:", fieldName: "expirationTime", span: 12 }
  ]),
  transferMessage: Object.freeze([
    { label: "汇款银行账户名称:", fieldName: "remittanceBankAccountName" },
    { label: "汇款银行账户账号:", fieldName: "remittanceBankAccountNo" },
    { label: "汇款开户行:", fieldName: "remittanceOpenBankName" },
    { label: "汇款开户行全称:", fieldName: "remittanceOpenBankFullName" },
    { label: "转账附言/用途:", fieldName: "remittanceTransferNotes" },
    {
      label: "支付凭证附件(银行盖章回执单):",
      fieldName: "fileName",
      slot: "file"
    }
  ]),
  invoiceMessage: Object.freeze([
    {
      label: "发票类型:",
      fieldName: "invoiceType",
      formateFn: function (val) {
        const invoiceTypeMap = {
          1: "增值税电子普通发票",
          2: "增值税专用发票（纸质）",
          3: "增值税普通发票",
          4: "增值税电子专用发票"
        };
        return invoiceTypeMap[val] || val;
      }
    },
    { label: "单位名称:", fieldName: "unitName" },
    { label: "纳税人识别号:", fieldName: "taxpayerNumber" },
    { label: "注册地址:", fieldName: "registeredAddress" },
    { label: "电话:", fieldName: "phone" },
    { label: "开户行:", fieldName: "openBank" },
    { label: "开户行账号:", fieldName: "openAccount" },
    { label: "手机号:", fieldName: "mobilePhone" },
    { label: "邮箱地址:", fieldName: "email" },
    { label: "发票备注:", fieldName: "remark" }
  ]),
  attachmentMessage: Object.freeze([
    { label: "发票号码:", fieldName: "invoiceNumber" },
    { label: "发票代码:", fieldName: "invoiceCode" },
    { label: "税率:", fieldName: "texRate" },
    { label: "开票日期:", fieldName: "createInvoiceDate" },
    {
      label: "发票附件:",
      fieldName: "fileName",
      slot: "file"
    }
  ])
}